<template>
  <v-container class="py-12">
    <TitleHeader> Consultas </TitleHeader>

    <v-row
      class="mt-12"
      justify="center"
      align="stretch"
      dense
    >
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-file-document-outline"
          title="Consulta de Selo Digital"
          href="https://consulta.funarpen.com.br/"
          color="blue-grey"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-magnify"
          title="Consulta de Selos de Autenticação"
          to="/funarpen/consultas/consulta-selos-autenticacao"
          color="indigo"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-check-circle-outline"
          title="Conferência de Certidões"
          to="/funarpen/consultas/consulta-certidao"
          color="green"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import TitleHeader from '@/components/TitleHeader.vue'
import NavigationCard from '@/components/NavigationCard.vue'

definePageMeta({
  middleware: 'manutencao',
  title: 'FUNARPEN - Consultas',
})

useHead({
  title: 'Consultas - FUNARPEN',
  meta: [{ name: 'description', content: 'Serviços de consulta da FUNARPEN.' }],
})
</script>

<style scoped>
/* Personalização opcional adicional */
</style>
